import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authApi } from '../api/client';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // On mount: check if we have a stored token and validate it
  useEffect(() => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      authApi.me()
        .then((res) => {
          setUser(res.data);
          localStorage.setItem('auth_user', JSON.stringify(res.data));
        })
        .catch(() => {
          // Token invalid or expired
          localStorage.removeItem('auth_token');
          localStorage.removeItem('auth_user');
          setUser(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await authApi.login({ email, password });
    const { access_token } = res.data;
    localStorage.setItem('auth_token', access_token);

    // Fetch user profile
    const meRes = await authApi.me();
    setUser(meRes.data);
    localStorage.setItem('auth_user', JSON.stringify(meRes.data));
    return meRes.data;
  }, []);

  const register = useCallback(async (email, username, password, invite_token) => {
    const res = await authApi.register({ email, username, password, invite_token });
    const { access_token } = res.data;
    localStorage.setItem('auth_token', access_token);

    // Fetch user profile
    const meRes = await authApi.me();
    setUser(meRes.data);
    localStorage.setItem('auth_user', JSON.stringify(meRes.data));
    return meRes.data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_user');
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return ctx;
}
